import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { RoomsService } from '../../services/rooms.service';
import { roomsActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoomsEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private roomsService: RoomsService,
  ) {}

  findOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(roomsActions.findOne),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        return this.roomsService.findOne(action.id).pipe(
          map((response) =>
            roomsActions.findOneSuccess({ room: response.data }),
          ),
          catchError((error: ApiError) =>
            of(roomsActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(roomsActions.findAll),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        return this.roomsService.findAll(action.page).pipe(
          map((response) =>
            roomsActions.findAllSuccess({
              rooms: response.data,
              total: response.total,
            }),
          ),
          catchError((error: ApiError) =>
            of(roomsActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
